export default __webpack_public_path__ + "static/media/partners-logo-chungnam-w@3x.50b0456c.webp";